
//Handlebars related code and helpers.
//Templates are stored as separate hbs files and compiled by gulp
//http://handlebarsjs.com/block_helpers.html
/*
    options argument returned:
    {
        data.root: full original data passed to hbs template
        fn: function(context)
        name: helper name
    }
    If iterating, like #each, then you can access each array item like so:
        var ret = "";

        for(var i=0, j=context.length; i<j; i++) {
            ret = ret + options.fn(context[i]);
        }

    //single object
    Handlebars.registerHelper('static', function(options) {

    });
    //array
    Handlebars.registerHelper('static', function(context,options) {

    });
*/

//e.g. {{#static}}{{imgurl}}{{/static}}

var handlebarsIsDeclared = true;
try{ Handlebars; }
catch(e) {
    if(e.name == "ReferenceError") {
        handlebarsIsDeclared = false;
    }
}

if(handlebarsIsDeclared){

    Handlebars.registerHelper('static', function(options) {
        return new Handlebars.SafeString(mantl.static_url + options.fn(this) );
    });

    Handlebars.registerHelper('mediaurl', function(options) {
        return new Handlebars.SafeString(mantl.media_url + options.fn(this) );
    });

    Handlebars.registerHelper('commenthelper', function(options) {
        var html = "";
        if(options.fn(this) == "") {
            html = '<i>No comments made.</i>';
        } else {
            html = options.fn(this);
        }

        return html;
    });

    Handlebars.registerHelper('evidence', function(options) {
        //console.log(options.fn(this), options);
        var html = "";
        return html;
    });

    Handlebars.registerHelper('verificationstatus', function(options) {
        var html = '<span class="flag flag--status">New</span>';
        if(options.fn(this) == "inprogress") {
            html = '<span class="flag flag--status flag--information">In Progress</span>';
        }
        if(options.fn(this) == "verified") {
            html = '<span class="flag flag--status flag--success">Verified</span>';
        }
        if(options.fn(this) == "unverified") {
            html = '<span class="flag flag--status flag--error">Failed</span>';
        }

        return html;
    });

    Handlebars.registerHelper('numberWithCommas', function(options) {
        var html = "";
        if(options.fn(this) != "") {
            html = numberWithCommas(options.fn(this));
        }
        return html;
    });

    Handlebars.registerHelper('formattedprice', function(options) {
        //prices are usually passed as integers in cents
        var html = "";
        if(options.fn(this) != "") {
            html = '' + roundedDecimal((options.fn(this)/100),2).toFixed(2);
        }

        return html;
    });

    Handlebars.registerHelper('formatteddate', function(options) {
        var html = "";
        if(options.fn(this) != "") {
            var format = 'MMM Do, YYYY [at] HH:mm';
            var timestamp = new Date(options.fn(this));
            timestamp = fecha.format(timestamp, format);
            html = '<time datetime="' + options.fn(this) + '">' + timestamp + '</time>';
        }

        return html;
    });

    Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {

        switch (operator) {
            case '==':
                return (v1 == v2) ? options.fn(this) : options.inverse(this);
            case '===':
                return (v1 === v2) ? options.fn(this) : options.inverse(this);
            case '!=':
                return (v1 != v2) ? options.fn(this) : options.inverse(this);
            case '!==':
                return (v1 !== v2) ? options.fn(this) : options.inverse(this);
            case '<':
                return (v1 < v2) ? options.fn(this) : options.inverse(this);
            case '<=':
                return (v1 <= v2) ? options.fn(this) : options.inverse(this);
            case '>':
                return (v1 > v2) ? options.fn(this) : options.inverse(this);
            case '>=':
                return (v1 >= v2) ? options.fn(this) : options.inverse(this);
            case '&&':
                return (v1 && v2) ? options.fn(this) : options.inverse(this);
            case '||':
                return (v1 || v2) ? options.fn(this) : options.inverse(this);
            default:
                return options.inverse(this);
        }
    });

    Handlebars.registerHelper('prefix', function() {
        return mantl.prefix;
    });

    Handlebars.registerHelper('lower', function(str) {
        return str.toLowerCase();
    });
}
